import { useModals } from "ModalProvider";
import PreviewImageModalView from "./PreviewImageModalView";

const ImageInlineView = ({ previewTitle = "Preview", images }) => {
  const modal = useModals();

  if (!images || images.length === 0) {
    return <div className="text-gray-500">No images</div>;
  }

  function previewImage(index) {
    modal.present({
      title: previewTitle,
      fullscreen: true,
      children: <PreviewImageModalView images={images} initialIndex={index} />,
    });
  }

  return (
    <div className="flex items-center gap-3 mt-2 overflow-x-auto py-1">
      {images.map((item, index) => (
        <button
          key={index}
          type="button"
          className=" h-16 shrink-0 rounded bg-gray-100 dark:bg-gray-800 overflow-hidden hover:shadow-md cursor-zoom-in"
          onClick={() => previewImage(index)}
        >
          <img
            src={item.thumb || item.url}
            alt={item.url}
            className="h-full w-auto object-cover"
          />
        </button>
      ))}
    </div>
  );
};

export default ImageInlineView;
